import { render, staticRenderFns } from "./customsClearance.vue?vue&type=template&id=335d13c3&"
import script from "./customsClearance.vue?vue&type=script&lang=js&"
export * from "./customsClearance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports